<script>
  import {getContext} from 'svelte';
  import {IMAGES} from '../images';

  const LG = getContext('LG');

  const iconVideos = [
    'https://img.phemex.com/v1/80cfbcb7-e397-4c69-a1d2-eb4d8c6d493d/copy-20965095-cecb-4-ee-4-8257-3-b50-b325-cf-56.MOV',
    'https://img.phemex.com/v1/905899d6-7e49-4450-ac37-627113022594/copy-a1-cc-3024-f56-e-417-f-92-cf-f2-a33-a9-f74-c8.MOV',
    'https://img.phemex.com/v1/5a4f5513-d5d8-4fe8-bd59-123a2ee77a8e/copy-5-a2-c09-b4-1-fe-4-4-af-4-af-46-1-db-6-f5744-ba-1.MOV',
    'https://img.phemex.com/v1/ae1037ea-b04b-479a-9d69-bf89efda8131/copy-23-da-6889-d2-e7-4-ceb-8-d37-ef-4-b76-f495-ca.MOV',
    'https://img.phemex.com/v1/31635a6b-7bb0-4ef1-97c3-b38fe721ce15/copy-9-f7229-d4-738-b-480-c-8-f3-f-e77-b2-be-24497.MOV',
  ];
  const covers = [IMAGES.ICON_POSTER_1, IMAGES.ICON_POSTER_2, IMAGES.ICON_POSTER_3, IMAGES.ICON_POSTER_4, IMAGES.ICON_POSTER_5];
  const coversH5 = ['https://img.phemex.com/v1/1685ac0c-1606-42de-9b30-2e779618ddd0/copy-08401602-a0-c8-4-fb-9-a0-ae-0-fd-30-edd-78-d9.mp4'];
  const videoDoms = [];

  let hideIndex = -1;

  function handleVideoOut() {
    hideIndex = -1;
    videoDoms.forEach((dom) => {
      dom.play();
    });
  }

  function handleVideoHoverFun(i) {
    return function () {
      videoDoms[i].pause();
      hideIndex = i;
    };
  }
</script>

<style>
  .icons {
    padding-bottom: 24px;
    gap: 40px;
  }
  .icon {
    flex: 1;
    cursor: pointer;
    overflow: hidden;
  }
  .icon video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .icon .bg-img {
    width: 100%;
    min-height: 134px;
  }
  .hide {
    display: none;
  }
  .icon-poster-sub {
    position: absolute;
    top: 0;
    right: -1.7%;
    height: 6.8%;
  }
  .pc {
    display: block;
  }
  .h5 {
    display: none;
  }
  @media screen and (max-width: 640px) {
    .icons {
      padding-top: 0;
      width: 100%;
    }
    .icon {
      flex: 1;
      width: auto;
      height: auto;
    }
    .pc {
      display: none;
    }
    .h5 {
      display: block;
    }
    .m-icon {
      height: 288px;
    }
  }
</style>

<div class="icons df jcc">
  {#each iconVideos as video, i}
    <div class="icon pr pc" on:mouseout={handleVideoOut} on:mouseover={handleVideoHoverFun(i)}>
      <img class="bg-img" src={covers[i]} />
      <video bind:this={videoDoms[i]} class="video" class:hide={hideIndex === i} autoplay loop muted src={video} />
    </div>
  {/each}
  <img class="icon-poster-sub pc" src={IMAGES.ICON_POSTER_5_SUB} />
  {#each coversH5 as video, i}
    <div class="icon pr h5 m-icon">
      <video class="video" autoplay loop muted src={video} />
    </div>
  {/each}
</div>
